import { Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
import { AuthGuard, CashierGuard, AdminGuard, ModuleGuard } from './core/auth';
import { ENUM } from './core/enum/enum';
var ɵ0 = function () { return import("./views/pages/auth/auth.module.ngfactory").then(function (m) { return m.AuthModuleNgFactory; }); }, ɵ1 = function () { return import("./views/pages/dashboard/dashboard.module.ngfactory").then(function (m) { return m.DashboardModuleNgFactory; }); }, ɵ2 = {
    moduleName: [ENUM.roles.ADMIN, ENUM.roles.AIRPORT]
}, ɵ3 = function () { return import("./views/pages/apps/mail/mail.module.ngfactory").then(function (m) { return m.MailModuleNgFactory; }); }, ɵ4 = {
    moduleName: [ENUM.roles.ADMIN]
}, ɵ5 = function () { return import("./views/pages/admin/company-management/company-management.module.ngfactory").then(function (m) { return m.CompanyManagementModuleNgFactory; }); }, ɵ6 = {
    moduleName: [ENUM.roles.ADMIN, ENUM.roles.OPERATION, ENUM.roles.FINANCIAL]
}, ɵ7 = function () { return import("./views/pages/admin/area-management/area-management.module.ngfactory").then(function (m) { return m.AreaManagementModuleNgFactory; }); }, ɵ8 = {
    moduleName: [ENUM.roles.ADMIN]
}, ɵ9 = function () { return import("./views/pages/admin/queue-management/queue-management.module.ngfactory").then(function (m) { return m.QueueManagementModuleNgFactory; }); }, ɵ10 = {
    moduleName: [ENUM.roles.ADMIN, ENUM.roles.OPERATION, ENUM.roles.AIRPORT]
}, ɵ11 = function () { return import("./views/pages/admin/reports/reports.module.ngfactory").then(function (m) { return m.ReportsModuleNgFactory; }); }, ɵ12 = {
    moduleName: [ENUM.roles.ADMIN, ENUM.roles.AIRPORT]
}, ɵ13 = function () { return import("./views/pages/admin/lookup-management/lookup-management.module.ngfactory").then(function (m) { return m.LookupManagementModuleNgFactory; }); }, ɵ14 = {
    moduleName: [ENUM.roles.ADMIN]
}, ɵ15 = function () { return import("./views/pages/admin/live-queue-statistics/live-queue-statistics.module.ngfactory").then(function (m) { return m.LiveQueueStatisticsModuleNgFactory; }); }, ɵ16 = {
    moduleName: [ENUM.roles.ADMIN, ENUM.roles.FINANCIAL, ENUM.roles.AIRPORT, ENUM.roles.OPERATION]
}, ɵ17 = function () { return import("./views/pages/admin/cashier-management/cashier-management.module.ngfactory").then(function (m) { return m.CashierManagementModuleNgFactory; }); }, ɵ18 = {
    moduleName: [ENUM.roles.ADMIN, ENUM.roles.FINANCIAL, ENUM.roles.AIRPORT]
}, ɵ19 = function () { return import("./views/pages/cashier/cashier.module.ngfactory").then(function (m) { return m.CashierModuleNgFactory; }); }, ɵ20 = {
    moduleName: [ENUM.roles.CASHIER]
}, ɵ21 = function () { return import("./views/pages/driver/driver.module.ngfactory").then(function (m) { return m.DriverModuleNgFactory; }); }, ɵ22 = {
    moduleName: [ENUM.roles.COMPANY_DRIVER]
}, ɵ23 = function () { return import("./views/pages/user-management/user-management.module.ngfactory").then(function (m) { return m.UserManagementModuleNgFactory; }); }, ɵ24 = {
    moduleName: [ENUM.roles.ADMIN]
}, ɵ25 = function () { return import("./views/theme/content/builder/builder.module.ngfactory").then(function (m) { return m.BuilderModuleNgFactory; }); }, ɵ26 = {
    moduleName: [ENUM.roles.ADMIN]
}, ɵ27 = {
    'type': 'error-v6',
    'code': 403,
    'title': '403... Access forbidden',
    'desc': 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
};
var routes = [
    { path: 'auth', loadChildren: ɵ0 },
    {
        path: '',
        component: BaseComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren: ɵ1,
                canActivate: [ModuleGuard],
                data: ɵ2
            },
            {
                path: 'mail',
                loadChildren: ɵ3,
                canActivate: [AdminGuard],
                data: ɵ4
            },
            {
                path: 'company-management',
                loadChildren: ɵ5,
                canActivate: [ModuleGuard],
                data: ɵ6
            },
            {
                path: 'area-management',
                loadChildren: ɵ7,
                canActivate: [AdminGuard],
                data: ɵ8
            },
            {
                path: 'queue-management',
                loadChildren: ɵ9,
                canActivate: [ModuleGuard],
                data: ɵ10
            },
            {
                path: 'reports',
                loadChildren: ɵ11,
                canActivate: [ModuleGuard],
                data: ɵ12
            },
            {
                path: 'lookup-management',
                loadChildren: ɵ13,
                canActivate: [AdminGuard],
                data: ɵ14
            },
            {
                path: 'live-queue-statistics',
                loadChildren: ɵ15,
                canActivate: [ModuleGuard],
                data: ɵ16
            },
            {
                path: 'cashier-management',
                loadChildren: ɵ17,
                canActivate: [ModuleGuard],
                data: ɵ18
            },
            {
                path: 'cashier',
                loadChildren: ɵ19,
                canActivate: [CashierGuard],
                data: ɵ20
            },
            {
                path: 'driver',
                loadChildren: ɵ21,
                canActivate: [ModuleGuard],
                data: ɵ22
            },
            {
                path: 'user-management',
                loadChildren: ɵ23,
                canActivate: [AdminGuard],
                data: ɵ24
            },
            {
                path: 'builder',
                loadChildren: ɵ25,
                canActivate: [AdminGuard],
                data: ɵ26
            },
            {
                path: 'error/403',
                component: ErrorPageComponent,
                data: ɵ27
            },
            { path: 'error/:type', component: ErrorPageComponent },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
    },
    { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27 };
